import React from 'react'
import VehicleItemContainer from './VehicleItemContainer'
import { vehicleShape } from '../../shapes'

const VehicleItem = ({ vehicle }) => (
  <VehicleItemContainer vehicle={vehicle} data-test="component-stock-vehicle-list-vehicle-item" />
)

VehicleItem.propTypes = {
  vehicle: vehicleShape.isRequired
}

export default VehicleItem
